"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFundingMechanics = void 0;
const common_1 = require("@finley-technologies/common");
const classes_1 = require("./classes");
const facility_1 = require("./facility");
const loans_1 = require("./loans");
const request_1 = require("./request");
// Translate from CA and (optional) evaluated borrowing base report for runtime use
const getFundingMechanics = ({ creditAgreement, loanMechanics: inputLoanMechanics, borrowingBaseReport, benchmarkRates, }) => {
    // ***** (1) FACILITY MECHANICS *****
    const { borrower, lenders } = (0, facility_1.getParties)(creditAgreement.facilityMechanics);
    const { bankAccounts } = (0, facility_1.getBankAccounts)(creditAgreement.facilityMechanics);
    // ***** (2) CLASS MECHANICS *****
    const classes = [];
    if (creditAgreement.classMechanics) {
        // Classes are currently funded by referencing attachment rate limits
        // Resolved attachment rates contained in borrowing base report output is required
        // Attachment rates are defined as formulas, but resolved to a number in data pipeline
        (0, common_1.finleyAssert)(borrowingBaseReport, `Borrowing base report is required for class level facility funding request.`);
        const { classes: fundingClasses } = (0, classes_1.getClasses)(creditAgreement.classMechanics, borrowingBaseReport);
        classes.push(...fundingClasses);
    }
    // ***** (3) LOAN MECHANICS *****
    const { loanMechanics } = (0, loans_1.getLoanMechanics)(inputLoanMechanics, creditAgreement.facilityMechanics.finalMaturityDate.value, lenders, classes);
    // ***** (4) REQUEST MECHANICS *****
    const { request } = (0, request_1.getRequest)(creditAgreement.fundingRequestMechanics, creditAgreement.reportingMechanics);
    return {
        borrower,
        lenders,
        classes,
        bankAccounts,
        loanMechanics,
        request,
        benchmarkRates,
    };
};
exports.getFundingMechanics = getFundingMechanics;
//# sourceMappingURL=index.js.map